import { render, staticRenderFns } from "./SaleItemDisplay.vue?vue&type=template&id=13da5a7a&lang=pug"
import script from "./SaleItemDisplay.vue?vue&type=script&lang=js"
export * from "./SaleItemDisplay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports